import validate from "validate.js";

export default () =>
validate.formatters.svelte = errors => {
	return errors.reduce((acc, err) => {
		let key = err.attribute;

		if (!acc[key]) {
			if (new RegExp('^.+[.].+$').test(key)) {
				// This if block handle innder keys
				// and make them key of objects
				key = key.split(".");

				const createObj = (keys, error) => {
					if (keys.length > 1) {
						return {
							[keys[0]]: createObj(keys, error)
						}
					} else {
						return {
							[keys[0]]: error
						}
					}
				}

				acc[key.shift()] = createObj(key, err.error);
			} else {
				acc[key] = err.error;
			}
		}

		return acc;
	}, {});
};